var Util = (function(self) {
  'use strict';

  self._init = function() {
  };

  // Определеет время до даты, результат в виде строки
  self.remainingTime = function(ctime, lang, sep) {


    var time = new Date();
    var newYear = new Date(ctime);
    var totalRemains =  (newYear.getTime() - time.getTime());

    var langRuS = ['секунд', 'секунды', 'секунду'],
      langRuM = ['минут', 'минуты', 'минуту'],
      langRuH = ['часов', 'часа', 'час'],
      langRuD = ['дней', 'дня', 'день'],
      langRuY = ['лет', 'года', 'год'],
      langEn = ['days', 'hours', 'minutes', 'seconds', 'years'],
      resLang = null;
    if (lang === 'ru_ru' || lang === 'ru_RU') {
      resLang = [langRuS, langRuM, langRuH, langRuD, langRuY];
    } else {
      resLang = [
        [langEn[3], langEn[3], langEn[3]],
        [langEn[2], langEn[2], langEn[2]],
        [langEn[1], langEn[1], langEn[1]],
        [langEn[0], langEn[0], langEn[0]],
        [langEn[4], langEn[4], langEn[4]]
      ];
    } // end if

    if (totalRemains > 1) {

      var RemainsSec = (parseInt(totalRemains / 1000));

      var RemainsFullYears = (parseInt(RemainsSec / (365 * 24 * 60 * 60)));
      if (totalRemains < 40000) RemainsFullYears = 0; // обход бага js с большим дес. числом, при totalRemains < 31000

      var secInLastYear = RemainsSec - RemainsFullYears * 365 * 24 * 3600;

      var RemainsFullDays = (parseInt(secInLastYear / (24 * 60 * 60)));
      var secInLastDay = secInLastYear - RemainsFullDays * 24 * 3600;

      var RemainsFullHours = (parseInt(secInLastDay / 3600));
      var secInLastHour = secInLastDay - RemainsFullHours * 3600;

      var RemainsMinutes = (parseInt(secInLastHour / 60));
      var lastSec = secInLastHour - RemainsMinutes * 60;

      // текст секунд
      var sSec = String(lastSec);
      var sSecLength = sSec.length;
      var sSecText = resLang[0][0];
      if (sSec.charAt(sSecLength - 2) != "1") {
        if (sSec.charAt(sSecLength - 1) == "2" ||
          sSec.charAt(sSecLength - 1) == "3" ||
          sSec.charAt(sSecLength - 1) == "4") {
          sSecText = resLang[0][1];
        } else if (sSec.charAt(sSecLength - 1) == "1") {
          sSecText = resLang[0][2];
        } // end if
      } // end if

      // текст минут
      var sMinute = String(RemainsMinutes);
      var sMinuteLength = sMinute.length;
      var sMinuteText = resLang[1][0];
      if (sMinute.charAt(sMinuteLength - 2) != "1") {
        if (sMinute.charAt(sMinuteLength - 1) == "2" ||
          sMinute.charAt(sMinuteLength - 1) == "3" ||
          sMinute.charAt(sMinuteLength - 1) == "4") {
          sMinuteText = resLang[1][1];
        } else if (sMinute.charAt(sMinuteLength - 1) == "1") {
          sMinuteText = resLang[1][2];
        } // end if
      } // end if

      // текст часов
      var sHour = String(RemainsFullHours);
      var sHourLength = sHour.length;
      var sHourText = resLang[2][0];
      if (sHour.charAt(sHourLength - 2) != "1") {
        if (sHour.charAt(sHourLength - 1) == "2" ||
          sHour.charAt(sHourLength - 1) == "3" ||
          sHour.charAt(sHourLength - 1) == "4") {
          sHourText = resLang[2][1];
        } else if (sHour.charAt(sHourLength - 1) == "1") {
          sHourText = resLang[2][2];
        } // end if
      } // end if

      // текст дней
      var sDay = String(RemainsFullDays);
      var sDayLength = sDay.length;
      var sDayText = resLang[3][0];
      if (sDay.charAt(sDayLength - 2) != "1") {
        if (sDay.charAt(sDayLength - 1) == "2" ||
          sDay.charAt(sDayLength - 1) == "3" ||
          sDay.charAt(sDayLength - 1) == "4") {
          sDayText = resLang[3][1];
        } else if (sDay.charAt(sDayLength - 1) == "1") {
          sDayText = resLang[3][2];
        } // end if
      } // end if

      // текст лет
      var sYear = String(RemainsFullYears);
      var sYearLength = sYear.length;
      var sYearText = resLang[4][0];
      if (sYear.charAt(sYearLength - 2) != "1") {
        if (sYear.charAt(sYearLength - 1) == "2" ||
          sYear.charAt(sYearLength - 1) == "3" ||
          sYear.charAt(sYearLength - 1) == "4") {
          sYearText = resLang[4][1];
        } else if (sYear.charAt(sYearLength - 1) == "1") {
          sYearText = resLang[4][2];
        } // end if
      } // end if


      var resultTime = '';
      if (RemainsFullYears !== 0) {
        resultTime += "<span className='timenumber'>" + RemainsFullYears +
          "</span> <span className='timeperiod'>" + sYearText+ "</span>" + sep;
      }
      if (RemainsFullDays !== 0) {
        resultTime += "<span className='timenumber'>" + RemainsFullDays +
          "</span> <span className='timeperiod'>" + sDayText+ "</span>" + sep;
      }
      if (RemainsFullHours !== 0) {
        resultTime += "<span className='timenumber'>" + RemainsFullHours +
          "</span> <span className='timeperiod'>" + sHourText+ "</span>" + sep;
      }
      if (RemainsMinutes !== 0) {
        resultTime += "<span className='timenumber'>" + RemainsMinutes +
          "</span> <span className='timeperiod'>" + sMinuteText+ "</span>" + sep;
      }
      resultTime += " <span className='timenumber'>" + lastSec +
        "</span> <span className='timeperiod'>" + sSecText + "</span>" ;

      return resultTime;
    } else {
      return 0;
    } // end if
  }; // end fun


  // Определеет время до даты, результат в виде строки
  self.getTotalRemains = function(ctime) {

    var time = new Date(), newYear = new Date(ctime);
    return  (newYear.getTime() - time.getTime());
  }; // end fun


  self.remainingAttempts = function(num) {
    var str = "";
    var left = "";
    var num = String(num);
    var last = num.length - 1;
    var lastNum = num.charAt(last);

    if (num > 10 && num < 20 ) {
      str = " осталось %n% попыток";
    } else if (lastNum == 1) {
      str = " осталась %n% попытка";
    } else if (lastNum >= 2 && lastNum <= 4) {
      str = " осталось %n% попытки";
    } else if (lastNum >= 5 && lastNum <= 9){
      str = " осталось %n% попыток";
    } else if (lastNum == 0){
      str = " осталось %n% попыток";
    }
    str = str.replace('%n%', num);

    return str;
  };
  self._init();
  return self;
})(Util || {});
window.Util = Util;
